import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './AdministrativeSystemUploadFolder.css';

const ADMIN_SYSTEM_ROOT =
  process.env.REACT_APP_ADMIN_SYSTEM_START_PATH ||
  process.env.REACT_APP_ADMIN_SYSTEM_BASE ||
  '/administrative-system';

function AdministrativeSystemUploadFolder({
  currentPath,
  userId,
  onFolderUploaded,
}) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={ADMIN_SYSTEM_ROOT}
      sessionPrefix="administrative_system_folder"
    />
  );
}

AdministrativeSystemUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default AdministrativeSystemUploadFolder;
